export enum CancellationPolicyId {
  STANDARD = "standard",
  FLEXIBLE = "flexible",
}
